import { selectComparableSalesChartData } from '../../../redux/features/selectors/selectComparableSalesChartData.ts';

export function convertComparableSalesDataToStringArray(
  data: ReturnType<typeof selectComparableSalesChartData>,
): [string[], ...string[][]] {
  const headerRow = ['', ...data.map((d) => d.header ?? '')];
  const dataRows = [
    ['DOM', ...data.map((d) => d.DOM?.toString() ?? '')],
    ['Original List Price', ...data.map((d) => d.originalListPrice ?? '')],
    ['Close Price', ...data.map((d) => d.closePrice ?? '')],
    ['SP as % LP', ...data.map((d) => d.salePriceAsPercentageOfListPrice ?? '')],
  ];
  return [headerRow, ...dataRows];
}
